import { useI18n } from "../i18n";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { SessionLog } from "./SessionLog";
import { History } from "./History";

export const SessionTabs = ({ tab, setTab, log, prediction, sessions, onDelete }) => {
  const { t } = useI18n();
  return (
  <Tabs value={tab} onValueChange={setTab} className="panel p-5">
    <TabsList className="bg-transparent p-0 gap-2 mb-4">
      <TabsTrigger value="log" className="tab" data-testid="ghost-log-tab">{t("log")}</TabsTrigger>
      <TabsTrigger value="prediction" className="tab" data-testid="ghost-prediction-tab">{t("prediction")}</TabsTrigger>
      <TabsTrigger value="history" className="tab" data-testid="ghost-history-tab">{t("archive")}</TabsTrigger>
    </TabsList>
    <TabsContent value="log"><SessionLog entries={log} /></TabsContent>
    <TabsContent value="prediction">
      <div className="py-6" data-testid="ghost-prediction-box">
        {prediction ? (
          <p className="font-heading text-xl sm:text-2xl text-primary leading-relaxed">“{prediction}”</p>
        ) : (
          <p className="text-subtle font-mono text-sm">{t("noPrediction")}</p>
        )}
      </div>
    </TabsContent>
    <TabsContent value="history"><History sessions={sessions} onDelete={onDelete} /></TabsContent>
  </Tabs>
  );
};
